module.exports = __webpack_public_path__ + "static/img/language.a84ceaa6.svg";